export const customConfig = {
  POCKETBASE_FILE_URL: `${process.env.REACT_APP_POCKETBASE_URL}/api/files`,
};
